import { useParams } from "react-router-dom";

import { getDossiersForContact } from "../../api/dossier/getDossiersForContact";
import PageContainer from "../../components/PageContainer";
import DossierList from "../../dossier/components/DossierList";

const ContactDossierListPage = () => {
  const { contactId } = useParams();

  if (!contactId) {
    // TODO: improve client side error messaging
    throw new Error("contact id param is misisng");
  }
  const response = getDossiersForContact(contactId);

  if (response.isError) {
    throw response.error;
  }

  return (
    <PageContainer loading={response.isFetching} title="Dossiers">
      {response.isSuccess && <DossierList dossiers={response.data} />}
    </PageContainer>
  );
};

export default ContactDossierListPage;
